import { Component, ViewChild } from "@angular/core"; import { Location } from "@angular/common";
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DonneesBaseService } from '../services/donnees-base-service';
import { BaseComponent } from '../base/base-component';
import { MessageService } from 'primeng/api';
import { ProfilService } from '../services/profil-service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppMainComponent } from '../app.main.component';
import { RequisitionService } from '../services/requisition-service';
import { BonCommandeEntite } from '../entites/bon-commande';

export interface ParametresConfirmationCreationBonCommande {
    bonsCommande: BonCommandeEntite[];
}

@Component({
    selector: 'app-confirmation-creation-bon-commande',
    templateUrl: './confirmation-creation-bon-commande.component.html'
})
export class ConfirmationCreationBonCommandeComponent extends BaseComponent {

    donnees: ParametresConfirmationCreationBonCommande;

    @ViewChild('boutonConfirmer') boutonConfirmer;

    constructor(
        profilService: ProfilService,
        route: ActivatedRoute, 
        appMain: AppMainComponent, location: Location, 
        private requisitionService: RequisitionService,
        public messageService: MessageService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public router: Router,
        public sdb: DonneesBaseService) {
        super(sdb, profilService, route, router, appMain);
    }

    ngOnInit() {
        this.donnees = this.config.data;
        this.CompleterChargement();
        setTimeout(() => {this.boutonConfirmer.nativeElement.focus(); }, 100);
    }

    confirmer() {
        this.ref.close(null);
    }

    voirBonCommande(bdc: BonCommandeEntite) {
        this.ref.close(true);
        this.router.navigateByUrl('achat/' + bdc.bonCommandeId.toString());
    }
}